import { object, ref, string } from 'yup';
import { passwordValidation } from '../../../components/PasswordField/config';

export const initialValues = {
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
};

export const validationSchema = object().shape({
  oldPassword: string().required('error.input.required'),
  newPassword: passwordValidation.required('error.input.required'),
  confirmPassword: string()
    .required('error.input.required')
    .oneOf([ref('newPassword')], 'error.input.password_mismatch'),
});
